export default __webpack_public_path__ + "static/media/close-up-view-of-printing-plastic-model-on-a-3d-printer-in-process-SBV-338489580-HD.710c530e.mp4";